import React, { useState, useEffect } from 'react';
import { Box } from '@mui/material';
import { useLocation } from 'react-router-dom';
import GenericLoader from '../../components/Loader/GenericLoader';
import DynamicTabsComponent from '../../components/DynamicTabs/DynamicTabsComponent';
import ManageLeaveRequestsComponent from './ManageLeaveRequests/ManageLeaveRequestsComponent';
import ManageProjectsComponent from './ManageProjects/ManageProjectsComponent';
import ManageWfhRequestsComponent from './ManageWfhRequests/ManageWfhRequestsComponent';
import ManageRemoteOfficeHoursTasksComponent from './ManageRemoteOfficeHoursTasks/ManageRemoteOfficeHoursTasksComponent';
import {
  SET_DATE_RANGE,
  TimesheetsComponentLoaderAttribute,
} from '../../constants';
import { useDispatch } from 'react-redux';
import { setFilterDataState } from '../../modules/filter/filterAction';
import { cardComponentExpand } from '../../modules/cardState/cardAction';
import { YYYY_MM_DD } from '../Tasks/TaskConstants';
import { MAIN_BLUE } from '../../color';
import moment from 'moment';
import ManagerWorkReportsComponent from './ManagerWorkReportsComponent';
import WeekendApprovalsInbox from '../WeekendWorking/WeekendApprovalsInbox';
import { getUserData } from '../../services/UserService';

const ManageComponent = (props) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const xyz = new URLSearchParams(location.search).get('xyz');
  const searchString = xyz ? window.atob(xyz) : '';

  const applierId = new URLSearchParams(searchString).get('applierId');
  const leaveStartDate = new URLSearchParams(searchString).get('startDate');
  const leaveEndDate = new URLSearchParams(searchString).get('endDate');
  const tabType = new URLSearchParams(searchString).get('type');
  const status = new URLSearchParams(searchString).get('status');

  const [showError, setShowError] = useState(false);
  const [loader, setLoader] = React.useState(false);
  const [userName, setUserName] = useState('');

  const [activeTab, setActiveTab] = React.useState(() => {
    if (tabType === 'LEAVE') return 1;
    if (tabType === 'WFH') return 2;
    if (tabType === 'REMOTE_OFFICE') return 3;
    if (tabType === 'WEEKEND_WORKING') return 4;
    return 0;
  });

  const getUserName = async () => {
    const response = await getUserData(applierId);
    if (response.isError == false)
      setUserName(response.data.firstName + ' ' + response.data.lastName);
    else setUserName('');
  };

  useEffect(() => {
    if (applierId) {
      getUserName();
    }
  }, []);

  useEffect(() => {
    if (tabType) {
      if (tabType === 'LEAVE') {
        setActiveTab(1);
      }
      if (tabType === 'WFH') {
        setActiveTab(2);
      }
      if (tabType === 'REMOTE_OFFICE') {
        setActiveTab(3);
      }
      if (tabType === 'WEEKEND_WORKING') {
        setActiveTab(4);
      }
      // External / Client Office / Work Travel approvals moved to Finance / Senior Manager inboxes.
      // Legacy EXTERNAL / CLIENT_OFFICE / WORK_TRAVEL deep links no longer open Manage tabs.
      if (
        tabType !== 'EXTERNAL' &&
        tabType !== 'CLIENT_OFFICE' &&
        tabType !== 'WORK_TRAVEL'
      ) {
        dispatch(
          setFilterDataState({
            employeeId: applierId,
            startDate: leaveStartDate,
            endDate: leaveEndDate,
            status: status,
          }),
        );
        dispatch({
          type: SET_DATE_RANGE,
          data: {
            startDate: moment(leaveStartDate).format(YYYY_MM_DD),
            endDate: moment(leaveEndDate).format(YYYY_MM_DD),
            color: MAIN_BLUE,
          },
        });
        dispatch(cardComponentExpand());
      }
    } else {
      setActiveTab(0);
    }
  }, [location, userName]);

  const ManageTabs = [
    {
      title: 'Projects',
      index: 0,
      component: <ManageProjectsComponent />,
    },
    {
      title: 'Leave Requests',
      index: 1,
      component: <ManageLeaveRequestsComponent />,
    },
    {
      title: 'WFH Requests',
      index: 2,
      component: <ManageWfhRequestsComponent />,
    },
    {
      title: 'Remote Office Hours',
      index: 3,
      component: <ManageRemoteOfficeHoursTasksComponent />,
    },
    {
      title: 'Weekend Working',
      index: 4,
      component: <WeekendApprovalsInbox />,
    },
    {
      title: 'Reports',
      index: 5,
      component: <ManagerWorkReportsComponent />,
    },
  ];

  return (
    <div>
      {loader ? (
        <div>
          <GenericLoader
            rectAttributes={TimesheetsComponentLoaderAttribute}
            showError={showError}
            setShowError={setShowError}
          />
        </div>
      ) : (
        <Box className="main-content-overlay">
          <div className="main-content-div">
            <DynamicTabsComponent
              activeTab={activeTab}
              setActiveTab={setActiveTab}
              TabsList={ManageTabs}
            />
          </div>
        </Box>
      )}
    </div>
  );
};

export default ManageComponent;
